/**
 * Lista centralizada de módulos do sistema.
 * Grupos espelham a estrutura do sidebar lateral.
 * Sub-funções dentro de telas são marcadas com subFunc: true.
 */
export const AVAILABLE_MODULES = [

  // ── Pessoal ────────────────────────────────────────────────────────────────
  { id: 'dashboard',              label: 'Início / Dashboard',                      group: 'Pessoal' },
  { id: 'agenda_pessoal',         label: 'Minha Agenda',                            group: 'Pessoal' },
  { id: 'meu_projeto',            label: 'Meu Projeto',                             group: 'Pessoal' },
  { id: 'minhas_tarefas',         label: 'Minhas Tarefas',                          group: 'Pessoal' },
  { id: 'convites',               label: 'Convites de Agenda / Avisos',              group: 'Pessoal' },
  { id: 'aulas',                  label: 'Aulas e Tutoriais para Cooperativas',     group: 'Pessoal' },
  { id: 'inep_ensino',            label: 'INEP — Instituto de Educação e Pesquisa', group: 'Pessoal' },
  { id: 'apresentacao_convenio',  label: 'Apresentação pro Convênio (demo com dados fictícios)', group: 'Direção' },
  { id: 'email',                  label: 'E-mail (caixas conectadas: ler, enviar, reuniões, prazos, pacientes)', group: 'Pessoal' },
  { id: 'teste_jarvis',           label: 'Zaping — WhatsApp (Ver = operador, Editar = supervisor)', group: 'Pessoal' },

  // ── Homecare — Captação ────────────────────────────────────────────────────
  { id: 'painel_captacao',        label: 'Painel Captação',                         group: 'Homecare — Captação' },
  { id: 'gestao_captacao',        label: 'Gestão Captação',                         group: 'Homecare — Captação' },
  { id: 'agenda_captacao',        label: 'Agenda Enf. Captação',                    group: 'Homecare — Captação' },
  { id: 'ocorrencias_setores',    label: 'Minhas Ocorrências',                      group: 'Homecare — Captação' },
  { id: 'gestao_ocorrencias',     label: 'Gestão de Ocorrências',                   group: 'Homecare — Captação' },
  { id: 'ocorrencias_supervisor', label: 'Supervisão de Ocorrências',               group: 'Homecare — Captação' },
  // Sub-funções dentro das telas de captação
  { id: 'nova_ocorrencia',        label: '↳ Criar Nova Ocorrência',                 group: 'Homecare — Captação', subFunc: true },
  { id: 'painel_implantados',     label: 'Painel Implantados',                      group: 'Homecare — Captação' },
  { id: 'intranet',              label: 'Intranet (Chat, Feed, Elogios, Ramais)',   group: 'Homecare — Captação' },

  // ── Homecare — Operacional ─────────────────────────────────────────────────
  { id: 'agenda_homecare',        label: 'Agenda Homecare',                         group: 'Homecare — Operacional' },
  { id: 'tarefas_homecare',       label: 'Tarefas Homecare',                        group: 'Homecare — Operacional' },
  { id: 'projeto_homecare',       label: 'Projeto Homecare',                        group: 'Homecare — Operacional' },
  { id: 'projeto_iw',             label: 'Projeto IW',                              group: 'Homecare — Operacional' },
  { id: 'cronograma_iw',          label: 'Cronograma IW',                           group: 'Homecare — Operacional' },
  { id: 'gestao_pacientes',       label: 'Cadastros de Pacientes',                  group: 'Homecare — Operacional' },
  { id: 'gestao_escalas',         label: 'Escalas de Técnicos',                     group: 'Homecare — Operacional' },
  { id: 'escalas_enfermeiros',    label: 'Escalas de Enfermeiros',                  group: 'Homecare — Operacional' },
  { id: 'formulario_passagem',    label: 'Form. Passagem Téc. Educação',            group: 'Homecare — Operacional' },
  { id: 'gestao_passagens',       label: 'Gestão de Passagens',                     group: 'Homecare — Operacional' },
  { id: 'portal_cooperativa',     label: 'Portal da Cooperativa',                   group: 'Homecare — Operacional' },
  { id: 'avaliacao_rh',           label: 'Liberação de Acesso RH',                  group: 'Homecare — Operacional' },
  { id: 'acessos_ti',             label: 'Criação de Acessos IW',                   group: 'Homecare — Operacional' },
  // Sub-funções dentro das telas operacionais
  { id: 'gestao_passagens_aprovar', label: '↳ Aprovar / Rejeitar Passagens',        group: 'Homecare — Operacional', subFunc: true },
  { id: 'upload_geolocalizacao',  label: '↳ Upload de Geolocalização',              group: 'Homecare — Operacional', subFunc: true },

  // ── Homecare — Assistencial ────────────────────────────────────────────────
  { id: 'gestao_remocoes',              label: 'Gestão de Remoções',              group: 'Homecare — Assistencial' },
  { id: 'gestao_solicitacao_remocao',   label: 'Solicitação de Remoção',          group: 'Homecare — Assistencial' },
  { id: 'gestao_feridas',               label: 'Gestão de Feridas',               group: 'Homecare — Assistencial' },
  { id: 'previa_recargas',              label: 'Prévia de Recargas',              group: 'Homecare — Assistencial' },
  { id: 'solicitacao_troca',            label: 'Troca de Dispositivo',            group: 'Homecare — Assistencial' },
  { id: 'controle_dispositivos',        label: 'Controle dos Dispositivos',       group: 'Homecare — Assistencial' },
  { id: 'liberacao_kits',               label: 'Liberação dos Kits',              group: 'Homecare — Assistencial' },
  { id: 'solicitacao_exames',           label: 'Exames',                          group: 'Homecare — Assistencial' },
  { id: 'monitoramento_clinico',        label: 'Monitoramento Clínico',           group: 'Homecare — Assistencial' },
  { id: 'envio_carefy',                 label: 'Envio ao Carefy',                 group: 'Homecare — Assistencial' },
  { id: 'intercorrencias',              label: 'Intercorrências',                 group: 'Homecare — Assistencial' },
  { id: 'gestao_ouvidorias',            label: 'Ouvidorias',                      group: 'Homecare — Assistencial' },
  { id: 'ouvidoria_monitoramento',      label: 'Ouvidoria Monitoramento',         group: 'Homecare — Assistencial' },
  { id: 'regras_contrato',              label: 'Regras de Contrato',              group: 'Homecare — Assistencial' },
  { id: 'huddle_homecare',              label: 'Huddle Homecare',                 group: 'Homecare — Assistencial' },

  // ── Homecare — Controladoria ───────────────────────────────────────────────
  { id: 'gestao_controladoria',         label: 'Controle de Notas',               group: 'Homecare — Controladoria' },
  { id: 'gestao_logistica',             label: 'Gestão da Logística',             group: 'Homecare — Controladoria' },

  // ── Dashboard ──────────────────────────────────────────────────────────────
  { id: 'dashboard_hub',          label: 'Dashboard Hub',                           group: 'Dashboard' },
  { id: 'dashboard_implantacao',  label: 'Dashboard Captação',                      group: 'Dashboard' },
  { id: 'dashboard_hospitalizacao',label:'Dashboard Hospitalização',                group: 'Dashboard' },
  { id: 'dashboard_feridas',      label: 'Dashboard Feridas',                       group: 'Dashboard' },
  { id: 'analysis',               label: 'Dashboard Projeto IW',                    group: 'Dashboard' },
  { id: 'uploads',                label: 'Uploads',                                 group: 'Dashboard' },
  { id: 'dashboard_indicadores',  label: 'Censo Homecare',                          group: 'Dashboard' },
  { id: 'mapa_pacientes',         label: 'Mapa de Pacientes',                       group: 'Dashboard' },
  { id: 'dashboard_planilha',     label: 'Dashboard Telefonia',                     group: 'Dashboard' },
  { id: 'telefonia_ao_vivo',      label: 'Telefonia ao Vivo (filas em tempo real)', group: 'Dashboard' },
  { id: 'dashboard_openzap',      label: 'Dashboard Openzap',                       group: 'Dashboard' },
  { id: 'dashboard_visitas',      label: 'Acomp. Visitas Domiciliares',             group: 'Dashboard' },
  { id: 'dashboard_prontuario',  label: 'Dashboard Prontuários',                   group: 'Dashboard' },
  { id: 'dashboard_dispositivos',label: 'Troca de Dispositivos',                   group: 'Dashboard' },
  { id: 'painel_infeccao',       label: 'Controle de Infecção',                    group: 'Dashboard' },
  { id: 'gestao_orcamentos',     label: 'Gestão de Orçamentos',                    group: 'Dashboard' },
  { id: 'pendencia_orcamentos',  label: 'Pendência de Orçamentos',                 group: 'Dashboard' },
  { id: 'contas_enviadas',       label: 'Envio de Contas (prorrogações)',          group: 'Dashboard' },
  { id: 'visitas_produtividade', label: 'Visitas × Produtividade',                 group: 'Dashboard' },

  // ── Qualidade ──────────────────────────────────────────────────────────────
  { id: 'agenda_qualidade',       label: 'Agenda de Qualidade',                     group: 'Qualidade' },
  { id: 'tarefas_qualidade',      label: 'Tarefas de Qualidade',                    group: 'Qualidade' },
  { id: 'indicadores',            label: 'Indicadores',                             group: 'Qualidade' },
  { id: 'indicador_agenda',       label: 'Indicadores de Agenda (Qualidade)',        group: 'Qualidade' },
  { id: 'documentos_qualidade',   label: 'Documentos / Fluxos',                     group: 'Qualidade' },
  // Sub-funções dentro das telas de qualidade
  { id: 'upload_indicadores',     label: '↳ Upload de Indicadores',                 group: 'Qualidade', subFunc: true },

  // ── Direção ────────────────────────────────────────────────────────────────
  { id: 'agenda_direcao',         label: 'Agenda da Direção',                       group: 'Direção' },
  { id: 'projeto_direcao',        label: 'Projeto Direção',                         group: 'Direção' },
  { id: 'obras_direcao',          label: 'Obras / Infraestrutura',                  group: 'Direção' },

  // ── Serviços / Chamados ────────────────────────────────────────────────────
  { id: 'abrir_chamado',          label: 'Abrir Chamado',                           group: 'Serviços / Chamados' },
  { id: 'meus_chamados',          label: 'Meus Chamados',                           group: 'Serviços / Chamados' },
  { id: 'painel_chamados',        label: 'Painel de Chamados (Sustentação)',        group: 'Serviços / Chamados' },

  // ── Administração ──────────────────────────────────────────────────────────
  { id: 'estoque_controle',       label: 'Estoque: Controle e Inventário',          group: 'Administração' },
  { id: 'estoque_solicitacao',    label: 'Estoque: Solicitar Material',             group: 'Administração' },
  { id: 'estoque_consumo',        label: 'Estoque: Relatórios de Consumo',         group: 'Administração' },
  { id: 'admin_tutoriais',        label: 'Gestão de Aulas',                         group: 'Administração' },
  { id: 'configuracoes',          label: 'Configurações do Sistema',                group: 'Administração' },
  { id: 'html_viewer',            label: 'Visualizador HTML',                       group: 'Administração' },
  { id: 'audit',                  label: 'Auditoria de Permissões',                 group: 'Administração' },
  { id: 'admin_eventos',          label: 'Gestão de Eventos',                       group: 'Administração' },
];

/** Permissões vazias para um usuário (base para montar o objeto) */
export const emptyPermissions = () =>
  AVAILABLE_MODULES.reduce((acc, m) => ({ ...acc, [m.id]: { view: false, edit: false } }), {});

/** Permissões completas (admin) */
export const allPermissions = () =>
  AVAILABLE_MODULES.reduce((acc, m) => ({ ...acc, [m.id]: { view: true, edit: true } }), {});

/** Perfis padrão para seed inicial do Firestore */
export const DEFAULT_PROFILES = [
  {
    name: 'Administrador', icon: '🛡️', color: '#6366f1',
    desc: 'Acesso total ao sistema e todas as configurações',
    roles: ['admin'], requiresSetor: false, requiresEquipe: false,
    permissions: allPermissions(),
  },
  {
    name: 'Auditora de Qualidade', icon: '🔍', color: '#10b981',
    desc: 'Agenda qualidade, ocorrências por setor e indicadores',
    roles: ['auditor_qualidade'], requiresSetor: true, requiresEquipe: false,
    permissions: {
      ...emptyPermissions(),
      dashboard:              { view: true,  edit: false },
      agenda_qualidade:       { view: true,  edit: true  },
      tarefas_qualidade:      { view: true,  edit: true  },
      ocorrencias_setores:    { view: true,  edit: true  },
      gestao_ocorrencias:     { view: true,  edit: false },
      indicadores:            { view: true,  edit: false },
      minhas_tarefas:         { view: true,  edit: true  },
      convites:               { view: true,  edit: false },
      abrir_chamado:          { view: true,  edit: true  },
    },
  },
  {
    name: 'Gestor Prontobaby', icon: '🏥', color: '#f59e0b',
    desc: 'Gestão de ocorrências e indicadores do Prontobaby',
    roles: ['gestor_prontobaby'], requiresSetor: true, requiresEquipe: false,
    permissions: {
      ...emptyPermissions(),
      dashboard:              { view: true,  edit: false },
      gestao_ocorrencias:     { view: true,  edit: true  },
      ocorrencias_supervisor: { view: true,  edit: false },
      indicadores:            { view: true,  edit: true  },
      minhas_tarefas:         { view: true,  edit: true  },
      abrir_chamado:          { view: true,  edit: true  },
    },
  },
  {
    name: 'Gestor Homecare', icon: '🏠', color: '#8b5cf6',
    desc: 'Agenda homecare, tarefas e gestão de pacientes',
    roles: ['gestor_homecare'], requiresSetor: false, requiresEquipe: false,
    permissions: {
      ...emptyPermissions(),
      dashboard:              { view: true,  edit: false },
      agenda_homecare:        { view: true,  edit: true  },
      projeto_homecare:       { view: true,  edit: true  },
      tarefas_homecare:       { view: true,  edit: true  },
      gestao_pacientes:       { view: true,  edit: true  },
      indicadores:            { view: true,  edit: false },
      minhas_tarefas:         { view: true,  edit: true  },
      abrir_chamado:          { view: true,  edit: true  },
    },
  },
  {
    name: 'Coordenador', icon: '📋', color: '#06b6d4',
    desc: 'Coordenação geral das atividades e equipes',
    roles: ['coordenador'], requiresSetor: false, requiresEquipe: false,
    permissions: {
      ...emptyPermissions(),
      dashboard:              { view: true,  edit: false },
      agenda_qualidade:       { view: true,  edit: false },
      agenda_homecare:        { view: true,  edit: false },
      gestao_ocorrencias:     { view: true,  edit: true  },
      indicadores:            { view: true,  edit: false },
      minhas_tarefas:         { view: true,  edit: true  },
      meu_projeto:            { view: true,  edit: true  },
      abrir_chamado:          { view: true,  edit: true  },
    },
  },
  {
    name: 'Colaborador', icon: '👤', color: '#3b82f6',
    desc: 'Acesso às ocorrências e atividades do seu setor',
    roles: ['colaborador'], requiresSetor: true, requiresEquipe: false,
    permissions: {
      ...emptyPermissions(),
      ocorrencias_setores:    { view: true,  edit: true  },
      gestao_ocorrencias:     { view: true,  edit: false },
      minhas_tarefas:         { view: true,  edit: true  },
      convites:               { view: true,  edit: false },
      abrir_chamado:          { view: true,  edit: true  },
    },
  },
  {
    name: 'Diretoria', icon: '⭐', color: '#f97316',
    desc: 'Agenda de direção, projetos estratégicos e obras',
    roles: ['diretoria'], requiresSetor: false, requiresEquipe: false,
    permissions: {
      ...emptyPermissions(),
      dashboard:              { view: true,  edit: false },
      agenda_direcao:         { view: true,  edit: true  },
      projeto_direcao:        { view: true,  edit: true  },
      obras_direcao:          { view: true,  edit: true  },
      agenda_qualidade:       { view: true,  edit: false },
      minhas_tarefas:         { view: true,  edit: true  },
      meu_projeto:            { view: true,  edit: true  },
      agenda_pessoal:         { view: true,  edit: true  },
      abrir_chamado:          { view: true,  edit: true  },
    },
  },
  {
    name: 'Secretaria da Direção', icon: '📅', color: '#ec4899',
    desc: 'Gestão completa da agenda e projetos de direção',
    roles: ['secretaria'], requiresSetor: false, requiresEquipe: false,
    permissions: {
      ...emptyPermissions(),
      dashboard:              { view: true,  edit: false },
      agenda_direcao:         { view: true,  edit: true  },
      projeto_direcao:        { view: true,  edit: true  },
      obras_direcao:          { view: true,  edit: true  },
      agenda_pessoal:         { view: true,  edit: true  },
      abrir_chamado:          { view: true,  edit: true  },
    },
  },
  {
    name: 'Cooperativa Parceira', icon: '🤝', color: '#14b8a6',
    desc: 'Portal da cooperativa, escalas e formulários',
    roles: ['cooperativa'], requiresSetor: false, requiresEquipe: true,
    permissions: {
      ...emptyPermissions(),
      portal_cooperativa:     { view: true,  edit: true  },
      gestao_escalas:         { view: true,  edit: false },
      escalas_enfermeiros:    { view: true,  edit: false },
      abrir_chamado:          { view: true,  edit: true  },
    },
  },
  {
    name: 'Escalista', icon: '📆', color: '#a855f7',
    desc: 'Gestão de escalas, passagens e cadastro de pacientes',
    roles: ['escalista'], requiresSetor: false, requiresEquipe: false,
    permissions: {
      ...emptyPermissions(),
      gestao_escalas:         { view: true,  edit: true  },
      escalas_enfermeiros:    { view: true,  edit: true  },
      formulario_passagem:    { view: true,  edit: true  },
      gestao_passagens:       { view: true,  edit: true  },
      gestao_pacientes:       { view: true,  edit: true  },
    },
  },
  {
    name: 'RH / Avaliador', icon: '👥', color: '#ef4444',
    desc: 'Liberação de acesso RH e portal de RH',
    roles: ['rh'], requiresSetor: false, requiresEquipe: false,
    permissions: {
      ...emptyPermissions(),
      avaliacao_rh:           { view: true,  edit: true  },
      abrir_chamado:          { view: true,  edit: true  },
    },
  },
  {
    name: 'TI / Acessos', icon: '💻', color: '#64748b',
    desc: 'Criação de acessos IW e suporte técnico',
    roles: ['ti'], requiresSetor: false, requiresEquipe: false,
    permissions: {
      ...emptyPermissions(),
      acessos_ti:             { view: true,  edit: true  },
      painel_chamados:        { view: true,  edit: true  },
      html_viewer:            { view: true,  edit: false },
    },
  },
];
